var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Total_SMS"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Total_SMS",
    clipPath: "url(#clip-Total_SMS)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3863",
    "data-name": "Path 3863",
    d: "M4.033,4.033h17.6v13.2H5.32L4.033,18.52V4.033m0-2.2a2.2,2.2,0,0,0-2.189,2.2l-.011,19.8,4.4-4.4h15.4a2.206,2.206,0,0,0,2.2-2.2V4.033a2.206,2.206,0,0,0-2.2-2.2Zm2.2,11h13.2v2.2H6.233Zm0-3.3h13.2v2.2H6.233Zm0-3.3h13.2v2.2H6.233Z",
    transform: "translate(2.167 2.167)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalSms);
export default __webpack_public_path__ + "static/media/Total_SMS.e7401a87735e92e8d6ba3f6a9e43d874.svg";
export { ForwardRef as ReactComponent };